export const data7_1_1 = [{
    name: 'SE',
    name_code: "SE",
    thisy_employee_num: 0,     //当月实际 员工数
    thisy_average_payroll: 0,    //当月实际 平均薪酬
    thisy_payroll_cost: 0,    //当月实际 薪酬成本
    lasty_employee_num: 0,    //去年当月实际 员工数
    lasty_average_payroll: 0,    //去年当月实际 平均薪酬
    lasty_payroll_cost: 0,    //去年当月实际 薪酬成本
    variance_emplyee_num: 0,    //今年对比去年 员工数
    ven_percent: 0,    //今年对比去年 百分比
    variance_average_payroll: 0,    //今年对比去年 平均薪酬
    vap_percent: 0,    //今年对比去年 百分比
    variance_payroll: 0,    //今年对比去年 薪酬成本
    vp_percent: 0,    //今年对比去年 百分比
    year_thisy_employee_num: 0,    //年累计 今年 员工数
    year_thisy_average_payroll: 0,    //年累计 今年 平均薪酬
    year_thisy_payroll_cost: 0,    //年累计 今年 薪酬成本
    year_lasty_employee_num: 0,    //年累计 去年 员工数
    year_lasty_average_payroll: 0,    //年累计 去年 平均薪酬
    year_lasty_payroll_cost: 0,    //年累计 去年 薪酬成本
    year_variance_emplyee_num: 0,    //年累计 今年对比去年 员工数
    year_ven_percent: 0,    //年累计 今年对比去年 百分比
    year_variance_average_payroll: 0,    //年累计 今年对比去年 平均薪酬
    year_vap_percent: 0,    //年累计 今年对比去年 百分比
    year_variance_payroll: 0,    //年累计 今年对比去年 薪酬成本
    year_vp_percent: 0,    //年累计 今年对比去年 百分比
}, {
    name: 'A1',
    name_code: "A1",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'A2',
    name_code: "A2",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'B1',
    name_code: "B1",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'B2',
    name_code: "B2",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'SS',
    name_code: "SS",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'S',
    name_code: "S",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'G1',
    name_code: "G1",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'G2',
    name_code: "G2",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'C',
    name_code: "C",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'T',
    name_code: "T",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Payroll Total 工资合计',
    name_code: "Payroll_Total",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Social Insurance and Housing Fund 五险一金',
    name_code: "Social_Insurance_and_Housing_Fund",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Incentive Program/Bonus Provision 绩效考核奖金/年终奖预提',
    name_code: "Bonus/Incentive_Provision",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: "Other Related Expenses 其他相关福利费用<br/>(包括合同津贴，交通、住宿、通讯补贴， 加班工资，法定假期，工作餐费等)",
    name_code: "Other_Related_Expenses",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Payroll Related Expenses 薪酬相关福利费用合计',
    name_code: "Payroll_Related_Expenses",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Total Payroll and Expenses 薪酬及相关福利合计',
    name_code: "Total_Payroll_and_Expenses",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'F&B 酒店餐饮劳务费用（包括劳务外包及帮工费用）',
    name_code: "",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Rooms 酒店房务劳务费用（包括劳务外包及帮工费用）',
    name_code: "",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Total Labor Outsourcing Expenses 酒店劳务费用合计',
    name_code: "",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: '酒店总人工成本及劳务费用占比 %',
    name_code: "",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}];

export const data7_1_2 = [{
    name: 'Rooms 客房',
    name_code: "Rooms",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Food & Beverage 餐饮',
    name_code: "Food_Beverage",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Administration& General 行政办 、财务、保安',
    name_code: "Administration_General",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Human Resources 人力资源部',
    name_code: "Human_Resources",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Sales & Marketing 市场销售部',
    name_code: "Sales_Marketing",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Property Operation & Maintenance 工程部',
    name_code: "Property_Operation_Maintenance",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Other Operated Departments 其它运营部门',
    name_code: "Other_Operated_Departments",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Payroll Total 工资合计',
    name_code: "Payroll_Total",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}];


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-1TotalPayrollCostAnalysis/data.js